export default __webpack_public_path__ + "static/media/restart-8.71bd7257.svg";